export default __webpack_public_path__ + "static/media/left-arrow-in-violet-circle.2a5e27fc.bin";